import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import WelcomeFeature from '@features/welcome';
import { useFormStore } from '@store/use-form-store';

function VisitorWelcomePage() {
  const navigate = useNavigate();
  const { changeRegistrationType, resetProcess } = useFormStore();

  const handleRegister = (type: string) => {
    resetProcess();
    changeRegistrationType(type);
    navigate(ROUTES.VR_REGISTER);
  };

  return (
    <WelcomeFeature
      onSingleRegister={() => handleRegister('single')}
      onMultipleRegister={() => handleRegister('multiple')}
    />
  );
}

export default VisitorWelcomePage;
